import React from "react";
import T from "prop-types";

import Widget from "2g-widget";
import { PageMessageError, PageMessageEmpty } from "2g-page-message";
import { isNotEmpty } from "2g-utils-common";

import { useProvozniInformace } from "b2b/api/hooks";

import useMessages from "./i18n/useMessages";
import HeaderActions from "./HeaderActions";
import DetailPlaceholder from "./DetailPlaceholder";
import Detail from "./Detail";
import Title from "./Title";
import TitleDescription from "./TitleDescription";

function ProvozniInformaceDetailWidget({ id }) {
  const messages = useMessages();
  const {
    data: provozniInformace,
    loading,
    loaded,
    error
  } = useProvozniInformace(id);

  if (loaded && error) {
    return <PageMessageError error={error} />;
  } else if (loading || (loaded && isNotEmpty(provozniInformace))) {
    return (
      <Widget
        className="b2b-ProvozniInformaceDetailWidget"
        collapsable={false}
        title={
          <Title loading={loading} provozniInformace={provozniInformace} />
        }
        titleDescription={
          <TitleDescription
            loading={loading}
            provozniInformace={provozniInformace}
          />
        }
        titleDescriptionOnlyBottom
        headerActions={<HeaderActions provozniInformace={provozniInformace} />}
      >
        {loading ? (
          <DetailPlaceholder />
        ) : (
          <Detail provozniInformace={provozniInformace} />
        )}
      </Widget>
    );
  } else {
    return <PageMessageEmpty message={messages.emptyMessage()} />;
  }
}

ProvozniInformaceDetailWidget.propTypes = {
  id: T.oneOfType([T.string, T.number])
};

export default React.memo(ProvozniInformaceDetailWidget);
